import { useState } from 'react';

import PublicHttpClient from '../../shared/infrastructures/clients/public-http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { PUBLIC_AUTHENTICATION_API_PATHS } from '../constants/authentication-paths.constants';
import { AuthenticatedUser, LoginRequestDTO } from '../types/authentication.dto';

const FALLBACK_MESSAGE = 'La connexion a échoué';

type UseLoginResult = {
  isSubmitting: boolean;
  error: string | null;
  submit: (payload: LoginRequestDTO) => Promise<AuthenticatedUser | null>;
};

export function useLogin(): UseLoginResult {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (payload: LoginRequestDTO): Promise<AuthenticatedUser | null> => {
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await PublicHttpClient.post<{ user: AuthenticatedUser }, LoginRequestDTO>(
        PUBLIC_AUTHENTICATION_API_PATHS.LOGIN,
        payload
      );

      return response.user;
    } catch (caught) {
      setError(extractApiErrorMessage(caught, FALLBACK_MESSAGE));

      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { isSubmitting, error, submit };
}
